import { render, staticRenderFns } from "./agentDownLevel.vue?vue&type=template&id=6b2a58c2"
import script from "./agentDownLevel.vue?vue&type=script&lang=js"
export * from "./agentDownLevel.vue?vue&type=script&lang=js"
import style0 from "./agentDownLevel.vue?vue&type=style&index=0&id=6b2a58c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports